<template>
  <BaseCard title="Invoice Terms" step-component="InvoiceTermsStep">
    <v-row>
      <v-col> Receive Invoices Via: {{ text }} </v-col>
    </v-row>
  </BaseCard>
</template>

<script>
import BaseCard from "@/components/registration/ReviewStepCards/BaseCard";
import { mapGetters, mapState } from "vuex";
export default {
  name: "InvoiceTerms",
  components: { BaseCard },
  computed: {
    ...mapGetters("baseData", ["getById"]),
    ...mapGetters("clients", ["selectedClient"]),
    ...mapState("clients", ["invoice_communication_types_selected"]),
    text() {
      return this.selectedClient.invoice_communication_types
        .map(type => type.name)
        .filter(name => !!name)
        .join(" ,");
    }
  },
  watch: {
    selectedClient(newVal) {
      this.client = newVal;
    }
  }
};
</script>

<style scoped></style>
